import React from "react";
import { ProjectCard } from "./ProjectCard";
import projImg1 from "../assets/img/project-img1.png";
import projImg2 from "../assets/img/project-img2.png";
import projImg3 from "../assets/img/project-img3.png";
import projImg4 from "../assets/img/project-img4.png";

const Projectsz = () => {
  const projects = [
    {
      title: "skinstore.com (React Rebuild)",
      description:
        "Design & Development using React, Chakra UI, Javascript, HTML/CSS, Bootstrap, RESTful API, Python. This is an complete rebuild of the original website skin store.com in react and also focused on optimizing performance",
      imgUrl: projImg1,
      link: "https://brilliant-peony-ec8019.netlify.app/",
      ts1: "HTML/CSS",
      ts2: "Javascript",
      ts3: "React JS",
      ts4: "Bootstrap",
      ts5: "Chakra UI",
      ts6: "RESTFUL API",
      ts7: "Python",
      gtLink: "https://github.com/arnabdasrishi/skinstore.com-React-Rebuild-",
    },
    {
      title: "FitnessHub",
      description:
        "Design & Development using React, Chakra UI, Javascript, HTML/CSS, Bootstrap, RESTful API, Python. Fitnesshub is the most accurate, comprehensive nutrition tracking app. It is clone website of cronometer.com.",
      imgUrl: "https://i.ibb.co/XtZcxyK/Screenshot-2023-01-09-235647.png",
      link: "https://projectfitnesshub.netlify.app/",
      ts1: "Javascript",
      ts2: "Chakra UI",
      ts3: "React JS",
      ts4: "Bootstrap",
      ts5: "Tailwaind",
      ts6: "RESTFUL API",
      gtLink: "https://github.com/srinetanuj/FitnessHub-.git",
    },
    {
      title: "Fiverr.com (replica)",
      description:
        "Design & Development using HTML/CSS, Vanilla Javascript, UI Libraries like bootstrap, jquery, tailwind. This project was build for making our primitve technologies concepts strong and revive our basic fundamentals. This was a group project.",
      imgUrl: projImg2,
      link: "https://fiverr-clone-22.netlify.app/",
      ts1: "HTML/CSS",
      ts2: "Javascript",
      ts3: "Bootstrap",
      ts4: "RESTFUL API",
      ts5: "JQuery",
      gtLink: "https://github.com/Suhaib-Malik01/Fiverr-Clone.git",
    },
    {
      title: "freshly.com",
      description:
        "design and development using primitive technologies. Freshly.com is a part of nestly group responsible of delivering healthier meals. This project was build using HTML, Javascript, CSS and other libbraries which was requied. This was a solo project.",
      imgUrl: projImg3,
      link: "https://vocal-choux-2758d7.netlify.app/",
      ts1: "HTML",
      ts2: "Javascript",
      ts3: "RESTFUL API",
      ts4: "CSS",
      gtLink: "https://github.com/arnabdasrishi/freshly.com-replica-.git",
    },
    {
      title: "Light Weather App (SPA)",
      description:
        "This a simple light wight weather application made using HTML, CSS, Javascript. Mainly focused on backend and optimization of the backend so that the frontend become smooth and quick. You can check out the rapid speed of loading weather of your area. Click on the like button.",
      imgUrl: projImg4,
      link: "https://hitemp.netlify.app/",
      ts1: "HTML/CSS",
      ts2: "Javascript",
      ts3: "React JS",
      ts4: "API Optimization",
      gtLink:
        "https://github.com/masai-course/arnab_fw20_0489/tree/master/unit-3/sprint-1/day-1/we",
    },
  ];

  return (
    <div style={{ textAlign: "center", margin:"1rem" }}>
      <h1 style={{marginBottom:"3rem"}}>Projects</h1>
      <div className="project-card-rsvp" style={{display:"flex", flexDirection:"column", marginBottom:"1rem"}}>
        {projects.map((items) => (
          <ProjectCard {...items} />
        ))}
      </div>
    </div>
  );
};

export default Projectsz;
